/* unplugin-vue-components disabled */import { render } from "./sSupport.vue?vue&type=template&id=2b0aba2e&scoped=true"
const script = {}

import "./sSupport.vue?vue&type=style&index=0&id=2b0aba2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0aba2e"]])

export default __exports__